import { useCallback } from 'react'

import { sideNavigationStore } from '../store/sideNavigationStore'

export const useSideNavigationHover = () => {
  const isHidden = sideNavigationStore.useStore((store) => store.isHidden)

  const onHoverStart = useCallback(() => {
    sideNavigationStore.cancelHoverHide()
    sideNavigationStore.setIsHovered(true)
  }, [])

  const onHoverEnd = useCallback(() => {
    sideNavigationStore.startHoverHide(500)
  }, [])

  return { isHidden, onHoverStart, onHoverEnd }
}
